import { useLocation, useNavigate } from "react-router-dom";
import { Back } from "../../compoment/icon";

import Male from './../../assets/img/Man1.png'
import Female from './../../assets/img/Woman1.png'
import BackBtn from "../../compoment/icon/BackBtn";


const ChooseAvatarScreen = () => {
    const navigate = useNavigate();
    const location = useLocation()

    const handleBack = () => {
        localStorage.removeItem('join');
        localStorage.removeItem('gender')
        navigate("/today-joining");
    };

    const handleChooseAvatar = (gender: string) => {
        const join = localStorage.getItem('join')
        localStorage.setItem('gender', gender)
        if (join === 'I am on my own') {
            navigate('/magic')
        } else {
            navigate('/choose-friend-avatar')
        }

    };

    return (
        <>
            <section className="colorSection portraitDevice">
                <div className="mainContainerSection">
                    <div>
                        <button className="backBTN" onClick={handleBack}>
                            <span className="me-2"><BackBtn /></span> Back
                        </button>
                    </div>
                    <div className="headingJoining mt-0">{`Choose your avatar`}</div>
                    <div className="lanternContainer" style={{ columnGap: 32 }}>
                        <div className="singleLanternJoining">
                            <div style={{ width: 250 }}> <img className="w-75 mx-auto" style={{ borderRadius: 12 }} src={Male} alt="" />  </div>
                            <button className="lanternBtn" onClick={() => handleChooseAvatar('male')}>Male</button>
                        </div>
                        <div className="singleLanternJoining">
                            <div style={{ width: 250 }}> <img className="w-75 mx-auto" style={{ borderRadius: 12 }} src={Female} alt="" /> </div>
                            <button className="lanternBtn" onClick={() => handleChooseAvatar('female')}>Female</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ChooseAvatarScreen;
